<p-dialog
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [(visible)]="discardConfirmDialog"
    [style]="{ width: '525px', height: '210px' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Discard changes?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text" style="margin-top: -13px">Are you sure you want to discard your changes? Any unsaved changes will be lost.</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-default btn-cancel" (click)="cancelDiscard()">Cancel</div>
        <div class="btn-profile btn-discard mr-3" (click)="discardConfirm()">Discard</div>
    </ng-template>
</p-dialog>